<ng-container [formGroup]="formGroup">
  <app-city-select [formControl]="city"
                   [classList]="cityClasses"></app-city-select>

  <app-store-select [formControl]="warehouse"
                    [clearEnabled]="false"
                    [cityRef]="cityRef"
                    [itemsFilterConfig]="itemsFilterConfig"
                    [autofocus]="autofocus"
                    [classList]="warehouseClasses"></app-store-select>
</ng-container>
